import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.css']
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  isImpersonating: boolean = false;
  agencyName: string | null = null;
  private subscription!: Subscription;

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.isImpersonating$.subscribe(val => {
      this.isImpersonating = val;
      this.agencyName = this.authService.impersonatingAgencyName;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  exitImpersonation(): void {
    this.authService.stopImpersonation().subscribe({
      next: () => {
        this.router.navigate(['/agencies']);
        setTimeout(() => window.location.reload(), 100);
      },
      error: (err: any) => {
        console.error('Failed to stop impersonation:', err);
      }
    });
  }
}
